import { render, staticRenderFns } from "./LaboratoriesListSkeletons.vue?vue&type=template&id=0c0fa94c&scoped=true&"
var script = {}
import style0 from "./LaboratoriesListSkeletons.vue?vue&type=style&index=0&id=0c0fa94c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0fa94c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c0fa94c')) {
      api.createRecord('0c0fa94c', component.options)
    } else {
      api.reload('0c0fa94c', component.options)
    }
    module.hot.accept("./LaboratoriesListSkeletons.vue?vue&type=template&id=0c0fa94c&scoped=true&", function () {
      api.rerender('0c0fa94c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Analyses/components/LaboratoriesList/components/LaboratoriesListSkeletons.vue"
export default component.exports